"use client";

import {createContext, useContext} from "react";
import type {ScriptDirection} from "@/utils/scriptVersioning/paths";

export const ScriptProposalReviewContext = createContext<{
   proposalId: string;
   scriptId: string;
   direction: ScriptDirection;
   conversationId: string;
   host: HTMLDivElement | null;
   setHost: (node: HTMLDivElement | null) => void;
   hasReview: boolean;
   setHasReview: (value: boolean) => void;
   finish: () => void;
} | null>(null);

export const useScriptProposalReview = () => useContext(ScriptProposalReviewContext);

/** The conversation shown beside a script page when the dock cannot hold it. */
export const ScriptProposalSideConversationContext = createContext<string | null>(null);
